module.exports = __webpack_public_path__ + "img/view.d53232fa.svg";